import { enumToI18nKey } from '~/utils/helpers';

export const USER_STATUS = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
} as { [key: string]: UsersApi.eUserStatus };

export const USER_STATUS_I18n = enumToI18nKey(USER_STATUS, 'USER_STATUS');